import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBookmark, BackendMutationDeleteBookmarkArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteUserBookmark($id: ID!) {
    deleteBookmark(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteBookmarkArgs;
type Result = Pick<BackendBookmark, 'id'>;

export const deleteUserBookmark = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
